<template>
  <div>
    <list
      row-key="DeliveryDocId"
      ref="list"
      unit="待发货订单"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.docList"
      @showRow="toggleRow"
      urlHash="business/sales/deliveryrelease/todo"
      :temp-params="{ DeliveryStatus: 0 }"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <el-table style="margin-top: 20px" :data="subList" border>
      <el-table-column
        align="left"
        prop="ProductNo"
        label="存货编号"
      ></el-table-column>
      <el-table-column
        align="left"
        prop="ProductName"
        label="存货名称"
        min-width="140px"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="ProductSpec" label="规格型号" align="left" />
      <el-table-column prop="PropertyName" label="属性" align="left" />
      <el-table-column prop="ColorName" label="颜色" align="left" />
      <el-table-column prop="SaUnitName" label="销售单位" align="left" />
      <el-table-column prop="RealQuantity" label="实发数" align="left" />
      <el-table-column prop="SpeciName" label="装箱规格" align="left" />
      <el-table-column prop="RealPackingNumber" label="每件数" align="left" />
      <el-table-column prop="PackingQuantity" label="件数" align="left" />
      <el-table-column
        prop="Remark"
        label="备注"
        align="left"
        show-overflow-tooltip
      />
      <el-table-column prop="OrderNo" label="来源单号" align="left" />
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/sales/deliveryrelease/todo/list.json";
import tableParam from "@/data/business/sales/deliveryrelease/todo/query.json";

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/sa/deliveryDoc").default,
      subList: [],
      params: {},
    };
  },
  methods: {
    toggleRow(data) {
      // console.log('data', data);
      this.subList = data.Products;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>